import { N_UserProfile } from "@specsheet-common/shared-types";

type UserInfo<T> = T &
  Pick<N_UserProfile, "name" | "lastName" | "email"> & {
    password?: string | null;
  };

export const trimUserFields = <T>(user: UserInfo<T>): UserInfo<T> => ({
  ...user,
  name: user.name.trim(),
  email: user.email.trim().toLowerCase(),
  lastName: user.lastName.trim(),
  ...(user.password ? { password: user.password.trim() } : {}),
});
